import {isFilled} from '@prismicio/client'
import {PrismicRichText} from '@prismicio/react'
import type {TextBlockSliceV3} from 'prismicio-types'

type TextBlockV3Props = {
  slice: TextBlockSliceV3 & {
    slice_type: string
    variation: string
  }
}

export const TextBlockV3 = ({slice}: TextBlockV3Props) => (
  <section
    data-slice-type={slice.slice_type}
    data-slice-variation={slice.variation}
    className="w-full bg-moss-white py-10 md:py-20"
  >
    <div className="mx-auto grid w-full max-w-[750px] px-6">
      <div className="flex flex-col gap-4" data-aos="fade-up">
        <div className="flex flex-col gap-3 md:gap-6">
          {isFilled.keyText(slice.primary.tag) && <p className="text-button-s text-moss-blue">{slice.primary.tag}</p>}
          {isFilled.richText(slice.primary.title) && (
            <div>
              <PrismicRichText
                field={slice.primary.title}
                components={{
                  heading2: ({children}) => (
                    <h2 className="lg:text-tg-h2 pb-2 text-32 leading-[normal] tracking-[-.32px] text-moss-black md:pb-4">
                      {children}
                    </h2>
                  ),
                  strong: ({children}) => <span className="font-normal text-moss-black/[60%]">{children}</span>,
                }}
              />
            </div>
          )}
        </div>

        <PrismicRichText
          field={slice.primary.text}
          components={{
            paragraph: ({children}) => (
              <p className="text-tg-body-l text-moss-black lg:text-18 lg:leading-[34px]">{children}</p>
            ),
          }}
        />
      </div>
    </div>
  </section>
)
